import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
 private theme: string = 'default';
 private env: string = 'development';
 currentTenant = atob(localStorage.getItem('encodedTenant'));


 private themes: any[] = [
  //ALMAYA
  {url: "https://almayacontroltower.cella.co.za/", tenantCode: 'ALMAYA', env: 'production'},
  {url: "https://almayacontroltowerqa.cella.co.za/", tenantCode: 'ALMAYA', env: 'qa'},
  {url: "https://almayacontroltowerdev.cella.co.za/", tenantCode: 'ALMAYA', env: 'development'},
  //FREIGHT
  {url: "https://sgfreightcontroltower.cella.co.za/", tenantCode: 'SGFRGT', env: 'production'},
  {url: "https://sgfreightcontroltowerqa.cella.co.za/", tenantCode: 'SGFRGT', env: 'qa'},
  {url: "https://sgfreightcontroltowerdev.cella.co.za/", tenantCode: 'SGFRGT', env: 'development'},
  //CONSUMER
  {url: "https://sgconsumercontroltower.cella.co.za/", tenantCode: 'SGCONS', env: 'production'},
  {url: "https://sgconsumercontroltowerqa.cella.co.za/", tenantCode: 'SGCONS', env: 'qa'},
  {url: "https://sgconsumercontroltowerdev.cella.co.za/", tenantCode: 'SGCONS', env: 'development'},
  //CONVENIENCE
  {url: "https://sgconveniencecontroltower.cella.co.za/", tenantCode: 'SGCONV', env: 'production'},
  {url: "https://sgconveniencecontroltowerqa.cella.co.za/", tenantCode: 'SGCONV', env: 'qa'},
  {url: "https://sgconveniencecontroltowerdev.cella.co.za/",tenantCode: 'SGCONV', env: 'development'},
  //LIEBEN
  {url: "https://liebencontroltower.cella.co.za/", tenantCode: 'LIEBEN', env: 'production'},
  {url: "https://liebencontroltowerqa.cella.co.za/", tenantCode: 'LIEBEN', env: 'qa'},
  {url: "https://liebencontroltowerdev.cella.co.za/", tenantCode: 'LIEBEN', env: 'development'},
 ]

constructor() { }

getCurrentTheme() : string {
  return this.theme;
}

getEnv(url: string) {
  this.themes.forEach((theme) => {
    if (url.includes(theme.url)) {
        this.env = theme.env
    } 
  });
  return this.env
}

getForURL(url: string) : string {
  this.themes.forEach((theme) => {
    if(url.includes(theme.url)) {
      this.theme = theme.tenantCode;
    }
  });
  return this.theme
}

setTheme(tenant: string) {
  const body = document.getElementsByTagName('body')[0];
  const tenantThemeName = tenant.toLowerCase()
  body.setAttribute('data-theme', tenantThemeName )
}

}
